import Cookies from 'js-cookie';

function AuthVerification() {
    return !!Cookies.get('auth');
}

export default AuthVerification;